var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _path5, _path6, _linearGradient4, _circle, _g, _linearGradient5, _circle2, _linearGradient6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d",
    gradientUnits: "userSpaceOnUse",
    x1: -7642.318,
    y1: -1052.43,
    x2: -7641.318,
    y2: -1052.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M42.516 50.393a2.522 2.522 0 01-2.514-2.514V7.744a2.522 2.522 0 012.514-2.514 2.522 2.522 0 012.514 2.514v40.135a2.521 2.521 0 01-2.514 2.514zM26.301 54.283v-3.325l13.7-5.71M45.031 45.158l13.915 5.8v3.325"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d",
    gradientUnits: "userSpaceOnUse",
    x1: 44.406,
    y1: 9.796,
    x2: 69.761,
    y2: 9.796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.136 7.993a3.595 3.595 0 01-3.115 3.565 3.358 3.358 0 01-1.365-.07 3.6 3.6 0 01-2.735-3.495h-16.89",
    fill: "none",
    stroke: "url(#SVGID_1_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d",
    gradientUnits: "userSpaceOnUse",
    x1: 15.621,
    y1: 9.796,
    x2: 40.626,
    y2: 9.796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 7.993h-16.54a3.601 3.601 0 01-3.09 3.565 3.384 3.384 0 01-1.365-.065 3.602 3.602 0 01-2.76-3.5",
    fill: "none",
    stroke: "url(#SVGID_2_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M7.862 39.69L19.676 9.796 31.489 39.69M53.51 39.69L65.324 9.796 77.138 39.69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M66.698 31.618s-.243-1.408-1.408-1.408-1.478 1.408-1.478 1.408l3.025 2.294M63.951 33.912s.243 1.408 1.408 1.408 1.478-1.408 1.478-1.408M65.324 29.01v1.2M65.324 35.321v1.199"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M66.698 31.618s-.243-1.408-1.408-1.408-1.478 1.408-1.478 1.408l3.025 2.294M63.951 33.912s.243 1.408 1.408 1.408 1.478-1.408 1.478-1.408M65.324 29.01v1.2M65.324 35.321v1.199"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d",
    gradientUnits: "userSpaceOnUse",
    x1: 57.889,
    y1: 32.695,
    x2: 72.76,
    y2: 32.695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.324,
    cy: 32.695,
    r: 6.811,
    fill: "none",
    stroke: "url(#SVGID_3_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M21.034 31.618s-.243-1.408-1.408-1.408-1.478 1.408-1.478 1.408l3.025 2.294M18.287 33.912s.243 1.408 1.408 1.408 1.478-1.408 1.478-1.408M19.66 29.01v1.2M19.66 35.321v1.199"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M21.034 31.618s-.243-1.408-1.408-1.408-1.478 1.408-1.478 1.408l3.025 2.294M18.287 33.912s.243 1.408 1.408 1.408 1.478-1.408 1.478-1.408M19.66 29.01v1.2M19.66 35.321v1.199"
  })))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d",
    gradientUnits: "userSpaceOnUse",
    x1: 12.225,
    y1: 32.695,
    x2: 27.096,
    y2: 32.695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.66,
    cy: 32.695,
    r: 6.811,
    fill: "none",
    stroke: "url(#SVGID_4_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d",
    gradientUnits: "userSpaceOnUse",
    x1: 23.372,
    y1: 56.677,
    x2: 61.709,
    y2: 56.677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.692 59.068H26.389a2.399 2.399 0 01-2.392-2.392v0a2.399 2.399 0 012.392-2.392h32.303a2.399 2.399 0 012.392 2.392v0a2.399 2.399 0 01-2.392 2.392z",
    fill: "none",
    stroke: "url(#SVGID_5_15692bd56d09cbf096321efcb1868c5b5f972217fa29c5bd4681171c20c61d6d)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M31.491 39.653H7.861l.001-.002v.039c0 3.3 2.7 6 6 6h11.627c3.3 0 6-2.7 6-6v-.039l.002.002zM77.139 39.653h-23.63l.001-.002v.039c0 3.3 2.7 6 6 6h11.627c3.3 0 6-2.7 6-6v-.039l.002.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceSheet);
export default __webpack_public_path__ + "static/media/balanceSheet.0415c07667366858303575e0cf60495d.svg";
export { ForwardRef as ReactComponent };